import {
    Alert,
    Button,
    Checkbox,
    CircularProgress,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Radio,
    RadioGroup,
    Snackbar,
    Typography,
} from '@mui/material';
import React, { useContext, useEffect, useReducer, useState } from 'react';
import SelectWithLabel from '../../../components/common/SelectWithLabel';
import TextArea from '../../../components/common/TextArea';
import AiTrainingDataContext from '../../AiTrainingDataContext';
//import PropTypes from 'prop-types';

function OrderSumSettingsRoot(props) {
    const [showPromptForEdit, setShowPromptForEdit] = useState(false);
    const [saveAsNewVersion, setSaveAsNewVersion] = useState(false);
    const [saveAsVersion, setSaveAsVersion] = useState('');
    const [callSummPrompt, setCallSummPrompt] = useState('');
    const [selectedPromptVersion, setSelectedPromptVersion] = useState('');
    const [allOrderSummPromptVersions, setAllOrderSummPromptVersions] =
        useState([]);
    const [isPromptReadOnly, setIsPromptReadOnly] = useState(false);
    const [loadingPrompt, setLoadingPrompt] = useState(false);
    const [savingPrompt, setSavingPrompt] = useState(false);

    const {
        //allOrderSummPromptVersions,
        fetchAllVersionsOfSummarizationPrompt,
        getOrderSummarizationPromptForVersion,
        saveCallSummarizationPrompt,
        restauId,
    } = useContext(AiTrainingDataContext);

    const initialMessageData = {
        showMessage: false,
        message: '',
        isSuccessMessage: null,
    };
    function displayMessageReducer(state, action) {
        //debugger;
        switch (action.type) {
            case 'SHOW_ERROR_MESSAGE':
                return { ...state, ...action.payload };
            case 'SHOW_SUCCESS_MESSAGE':
                return { ...state, ...action.payload };
            case 'RESET':
                return initialMessageData;
            default:
                return state;
        }
    }

    const [displayMessageToUser, dispatchMessageToDisplay] = useReducer(
        displayMessageReducer,
        initialMessageData
    );

    const resetMessageToDisplay = () => {
        dispatchMessageToDisplay({
            type: 'RESET',
        });
    };

    const onChangePromptVersion = (newVal) => {
        setIsPromptReadOnly(allOrderSummPromptVersions[0].value !== newVal);
        setSelectedPromptVersion(newVal);
        setShowPromptForEdit(false);
    };

    const loadVersionsData = async () => {
        let tempdata = [];
        let data = await fetchAllVersionsOfSummarizationPrompt();
        if (!data) {
            // alert(
            //     'Failed while fetching versions for Call Summarization prompt.'
            // );
            dispatchMessageToDisplay({
                type: 'SHOW_ERROR_MESSAGE',
                payload: {
                    showMessage: true,
                    message:
                        'Failed while fetching versions for Call Summarization prompt.',
                    isSuccessMessage: false,
                },
            });
            return;
        }
        if (data.length > 0) {
            tempdata = [
                ...data.map((val, index) => {
                    return {
                        id: val.id,
                        //docId: val.docId,
                        label:
                            (index === 0 ? 'latest (' : '') +
                            val.majorVersion +
                            '.' +
                            val.minorVersion +
                            (index === 0 ? ')' : ''),
                        value: val.majorVersion + '.' + val.minorVersion,
                    };
                }),
            ];
        } else {
            tempdata = [
                {
                    id: 'new',
                    //docId: undefined,
                    label: 'latest (1.0)',
                    value: '1.0',
                },
            ];
        }
        //debugger;
        setSelectedPromptVersion(tempdata[0].value);
        setAllOrderSummPromptVersions(tempdata);
        setShowPromptForEdit(false);
        setSaveAsNewVersion(false);
        setSaveAsVersion('saveAsNewMinor');
    };

    const savePromptAsVersion = async () => {
        try {
            setSavingPrompt(true);
            let res = await saveCallSummarizationPrompt(
                callSummPrompt,
                selectedPromptVersion,
                allOrderSummPromptVersions[0].id,
                saveAsNewVersion,
                saveAsVersion
            );
            if (res) {
                //alert('Call Summarization prompt saved succesfully!');
                dispatchMessageToDisplay({
                    type: 'SHOW_SUCCESS_MESSAGE',
                    payload: {
                        showMessage: true,
                        message: 'Call Summarization prompt saved succesfully!',
                        isSuccessMessage: true,
                    },
                });
            }
        } catch (ex) {
            //alert('Failed to save Call Summarization prompt', ex.toString());
            dispatchMessageToDisplay({
                type: 'SHOW_ERROR_MESSAGE',
                payload: {
                    showMessage: true,
                    message:
                        'Failed to save Call Summarization prompt' +
                        ex.toString(),
                    isSuccessMessage: false,
                },
            });
        } finally {
            setSavingPrompt(false);
            loadVersionsData();
        }
    };

    const getOrderSummarizationPrompt = async () => {
        //debugger;
        let res = {};
        setLoadingPrompt(true);
        let promptVersionId = allOrderSummPromptVersions.filter(
            (x) => x.value === selectedPromptVersion
        )[0].id;
        if (promptVersionId === 'new') {
            res = { prompt: '' };
        } else {
            // let majorVersion = parseInt(selectedPromptVersion.split('.')[0]);
            // let minorVersion = parseInt(selectedPromptVersion.split('.')[1]);
            res = await getOrderSummarizationPromptForVersion(promptVersionId);
        }
        setLoadingPrompt(false);
        setCallSummPrompt(res.prompt);
        setShowPromptForEdit(true);
    };

    useEffect(() => {
        if (!restauId) return;
        loadVersionsData();
    }, [restauId]);

    return (
        <>
            <Snackbar
                open={displayMessageToUser.showMessage}
                autoHideDuration={6000}
                onClose={resetMessageToDisplay}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={resetMessageToDisplay}
                    severity={
                        displayMessageToUser.isSuccessMessage
                            ? 'success'
                            : 'error'
                    }
                    sx={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    {displayMessageToUser.message}
                </Alert>
            </Snackbar>
            <Grid container spacing={1.5}>
                <Grid item xs={12}>
                    <Typography variant="h6" sx={{ fontSize: '1.2em' }}>
                        Order Summarization Prompt
                    </Typography>
                </Grid>
                {allOrderSummPromptVersions.length === 0 ? (
                    <CircularProgress size={24} style={{ color: 'black' }} />
                ) : (
                    <Grid
                        item
                        container
                        alignItems={'center'}
                        columnSpacing={1}
                    >
                        <Grid item xs={1.2}>
                            <SelectWithLabel
                                items={allOrderSummPromptVersions}
                                label={'Version'}
                                size={'medium'}
                                value={selectedPromptVersion}
                                onChangeHandler={(newValue) => {
                                    onChangePromptVersion(newValue);
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <Button
                                disabled={loadingPrompt}
                                color="primary"
                                size="large"
                                style={{
                                    height: 'max-content',
                                    marginRight: '10px',
                                }}
                                variant="contained"
                                onClick={getOrderSummarizationPrompt}
                            >
                                Fetch
                                {loadingPrompt && (
                                    <CircularProgress
                                        size={24}
                                        style={{ color: 'black' }}
                                    />
                                )}
                            </Button>
                        </Grid>
                    </Grid>
                )}
                {showPromptForEdit && (
                    <>
                        <Grid item xs={12}>
                            <TextArea
                                minRows={21}
                                maxRows={21}
                                placeholder={'placeholder text..'}
                                style={{
                                    width: '99%',
                                    minWidth: '100%',
                                    maxWidth: '100%',
                                    padding: '10px',
                                }}
                                isDisabled={isPromptReadOnly}
                                value={callSummPrompt}
                                onChange={(e) =>
                                    setCallSummPrompt(e.target.value)
                                }
                            ></TextArea>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            container
                            spacing={1}
                            alignItems={'flex-start'}
                        >
                            <Grid item xs={12} sm={6} md={6} lg={3.5}>
                                <FormControl component="fieldset">
                                    <FormLabel
                                        component="legend"
                                        style={{
                                            cursor: isPromptReadOnly
                                                ? 'not-allowed'
                                                : 'auto',
                                        }}
                                    >
                                        <Checkbox
                                            disabled={isPromptReadOnly}
                                            checked={saveAsNewVersion}
                                            onChange={(e) =>
                                                setSaveAsNewVersion(
                                                    e.target.checked
                                                )
                                            }
                                            style={{
                                                padding: '0 8px 0 0',
                                            }} // optional: reduce padding if you want tighter spacing
                                        />
                                        Save As New Version
                                    </FormLabel>
                                    {saveAsNewVersion && (
                                        <RadioGroup
                                            aria-label="print1"
                                            name="print1"
                                            row
                                            value={saveAsVersion}
                                            //onChange={handleChange}
                                        >
                                            <FormControlLabel
                                                value="saveAsNewMinor"
                                                control={<Radio />}
                                                label="New Minor Version"
                                                onChange={() =>
                                                    setSaveAsVersion(
                                                        'saveAsNewMinor'
                                                    )
                                                }
                                            />
                                            <FormControlLabel
                                                value="saveAsNewMajor"
                                                control={<Radio />}
                                                label="New Major Version"
                                                onChange={() =>
                                                    setSaveAsVersion(
                                                        'saveAsNewMajor'
                                                    )
                                                }
                                            />
                                        </RadioGroup>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={2}>
                                <Button
                                    disabled={isPromptReadOnly || savingPrompt}
                                    color="primary"
                                    size="large"
                                    style={{
                                        height: 'max-content',
                                        marginRight: '10px',
                                    }}
                                    variant="contained"
                                    onClick={savePromptAsVersion}
                                >
                                    Save
                                    {savingPrompt && (
                                        <CircularProgress
                                            size={24}
                                            style={{ color: 'black' }}
                                        />
                                    )}
                                </Button>
                            </Grid>
                        </Grid>
                    </>
                )}
            </Grid>
        </>
    );
}

OrderSumSettingsRoot.propTypes = {};

export default OrderSumSettingsRoot;
